<template>
    <div class="custom-container">        
            <div class="conferencing-maintenance-banner">
                <div class="conferencing-maintenance-banner__content">
                    <span class="conferencing-maintenance-banner__content_icon">
                        <img src="@/assets/images/maintenance@2x.png" />
                    </span>
                    <span v-if="releaseInfo && releaseInfo.message">
                        {{releaseInfo.message}}
                    </span>
                </div>
                <span class="conferencing-maintenance-banner__close" >
                    <a @click="closeMaintenanceBanner()">
                        <img src="@/assets/images/black_close@2x.png" />
                    </a>
                </span>
            </div>        
        </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { setBrowserCookie, getBrowserCookie } from '@/utils/helper';
import moment from "moment";
import Constants from "@/utils/constants";

// Import composables
import { useConferenceCall, useGlobal } from '@/composables/';

// Define component name
defineOptions({
    name: 'MaintenanceBanner'
});

// Initialize composables
const {
    releaseInfo,
} = useConferenceCall();

const {
    setHideMaintenanceBanner,
} = useGlobal();

// Reactive data
const cookieName = ref('');

// Methods
const initializeBanner = () => {
    let hideBanner = true;
    if (!releaseInfo.value) {
        setHideMaintenanceBanner(true);
        return;
    }

    if (releaseInfo.value != null && releaseInfo.value.id > 0) {
        hideBanner = false;          
    }
    const hasReleaseMessage = releaseInfo.value.message.length > 0;            
    cookieName.value = Constants.MaintenanceBannerCookie + "_id_" + releaseInfo.value.id; 
    const index = releaseInfo.value.endDate.lastIndexOf(':');
    const dateString = releaseInfo.value.endDate.substring(0, index).replace(/-/g, '/');    
    hideBanner = moment.utc().isAfter(moment.utc(dateString)) || getBrowserCookie(cookieName.value) || !hasReleaseMessage;
    setHideMaintenanceBanner(hideBanner);
};

const closeMaintenanceBanner = () => {
    setBrowserCookie(cookieName.value, true, 365);
    const hideBanner = getBrowserCookie(cookieName.value);
    setHideMaintenanceBanner(hideBanner);
};

// Lifecycle hooks
onMounted(() => {
    initializeBanner();
});
</script>
<style lang="stylus">
.conferencing-maintenance-banner {
    color: #1f1f1f;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    background: #fff7cc;
    min-height: 35px;
    width: 100%;
    border-bottom: 1px solid #f2e5a9;
    z-index: 1000;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    &__content {
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: center;
        flex: 1;

        &_icon img {
            margin-left: 8px;
            margin-right: 5px;
            height: 14px;
        }
    }

    &__close {
        display: flex;
        cursor: pointer;
        margin-right: 12px;
        box-sizing: border-box;
        height: 19px;
        width: 19px;
        border: 1px solid #E0D8A3;;
        border-radius: 3px;

        img {
            width: 8px;
            height: 8px;
            margin-top: 4px;
            margin-left: 4px;
        }
    }
    .custom-container {
        height: 35px;
        width: 100%;
    }
}
</style>
